module.exports = __webpack_public_path__ + "img/img15.619fdfb2.svg";